import { CLIENT_ENVS } from '@/helpers/constants';

export interface IJackpotHitRangeCents {
  fromCents: number;
  toCents: number;
}

export interface IJackpotCampaignLevel {
  id: string;
  code: string;
  name: string;
  poolCents: number;
  isTargetSet: boolean;
  minBetAmountCents: number;
  maxBetAmountCents: number;
  minBetCount: number;
  minTotalBetAmountCents: number;
  hitRange: IJackpotHitRangeCents;
}

export interface IJackpotCampaign {
  id: string;
  code: string;
  name: string;
  startsAt: string;
  endsAt: string;
  levels: IJackpotCampaignLevel[];
}

export interface IJackpotCampaignsResponse {
  campaigns: IJackpotCampaign[];
}

export interface IJackpotWinHistoryItem {
  id: string;
  campaignId: string;
  levelId: string;
  levelCode: string | null;
  levelName: string;
  wonAt: string;
  winnerFirstName: string | null;
  amountCents: number;
}

export interface IJackpotFeaturedGamesCampaign {
  campaignId: string;
  games: string[];
}

export interface IJackpotFeaturedGamesResponse {
  campaigns: IJackpotFeaturedGamesCampaign[];
}

const JACKPOT_API_PATH = '/api/v1/jackpot';

const requestJackpotApi = async <T>(path: string): Promise<T> => {
  const baseUrl = CLIENT_ENVS.JACKPOT_API_URL;

  if (!baseUrl) {
    throw new Error('Jackpot API URL is not configured');
  }

  const response = await fetch(`${baseUrl}${JACKPOT_API_PATH}${path}`, {
    cache: 'no-store',
    headers: { Accept: 'application/json' },
  });

  if (!response.ok) {
    throw new Error(`Jackpot API error: ${response.status}`);
  }

  return response.json() as Promise<T>;
};

export const fetchJackpotCampaigns = () =>
  requestJackpotApi<IJackpotCampaignsResponse>('');

export const fetchJackpotWinHistory = (page = 1) =>
  requestJackpotApi<IJackpotWinHistoryItem[]>(`/win-history?page=${page}`);

export const fetchJackpotFeaturedGames = () =>
  requestJackpotApi<IJackpotFeaturedGamesResponse>('/featured-games');
